/*=========================================================================================
  File Name: module-dictionary-actions.js
  Description: Dictionary Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import DictionaryAPI from '@/api/DictionaryAPI.js';
import TaxPayerInfoAPI from '@/api/TaxPayerInfoAPI.js';
import NpsAPI from '@/api/NpsAPI.js';
import GipAPI from '@/api/GipAPI.js';
import httpClient from '../../api/axios-httpclient';
import AdminProcedureAPI from '@/api/AdminProcedureAPI.js';

export default {
	// gọi ra thông tin location đơn vị hành chính
	loadAreaList: async function(context, payload) {
		let res = await httpClient.postAsync(
			{ url: DictionaryAPI.getAPIUrl() + '/getarea', data: payload },
			true,
			false
		);

		if (res.Success) {
			switch (payload.Kind) {
				case 1:
					context.commit('updateProvinceList', res);
					break;
				case 2:
					context.commit('updateDistrictList', res);
					break;
				case 3:
					context.commit('updateWardList', res);
					break;
			}

			return res.Data;
		}

		return [];
	},
	// gọi ra thông tin quan lý thu
	loadTaxAgencyList: async function(context, payload) {
		let res = await httpClient.postAsync(
			{ url: DictionaryAPI.getAPIUrl() + '/gettaxagency', data: payload },
			true
		);

		if (res.Success) {
			context.commit('updateTaxAgencyList', res);
			return res.Data;
		}

		return [];
	},
	// gọi ra toàn bộ thông tin quan lý thu
	loadAllTaxAgencyList: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: DictionaryAPI.getAPIUrl() + '/getalltaxagency',
				params: payload
			},
			true
		);

		if (res.Success) {
			context.commit('updateAllTaxAgencyList', res);
			return res.Data;
		}

		return [];
	},
	// Lấy danh sách kho bạc nhà nước
	loadTreasuryList: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: DictionaryAPI.getAPIUrl() + '/gettreasury',
				data: payload
			},
			true
		);

		if (res.Success) {
			context.commit('updateTreasuryList', res);
			return res.Data;
		}

		return [];
	},

	// Lấy danh sách ngân hàng kho bạc ủy nhiệm
	loadTreasuryBankList: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: DictionaryAPI.getAPIUrl() + '/getbanktreasury',
				data: payload
			},
			true,
			false
		);

		if (res.Success) {
			context.commit('updateTreasuryBankList', res);
			return res.Data;
		}

		return [];
	},

	// Lấy danh sách mã chương theo quy định
	loadChapterList: async function(context, options) {
		let res = await httpClient.postAsync({
			url: DictionaryAPI.getAPIUrl() + '/getchapter',
			data: options
		});

		if (res.Success) {
			context.commit('updateChapterList', res);
			return res.Data;
		}

		return [];
	},

	// Lấy danh sách nội dung kinh tế
	loadEconomicsList: async function(context, options) {
		let res = await httpClient.postAsync({
			url: DictionaryAPI.getAPIUrl() + '/geteconomics',
			data: options
		});
		if (res.Success) {
			context.commit('updateEconomicsList', res);
			return res.Data;
		}

		return [];
	},

	// Lấy danh sách ngân hàng phục vụ cho nộp thuế điện tử
	loadBankList: async function(context, options) {
		let res = await httpClient.postAsync(
			{
				url: DictionaryAPI.getAPIUrl() + '/getbank',
				data: options
			},
			true
		);

		if (res.Success) {
			context.commit('updateBankList', res);
		}

		return res;
	},

	// Lấy ra thông tin người thụ hưởng. Khi tìm kiếm theo mã số thuế
	organizationInfo: async function(context, options) {
		let res = await httpClient.getAsync(
			{
				url: DictionaryAPI.getAPIUrl() + '/getorganizationinfo',
				params: options
			},
			true
		);

		if (res.Data) {
			return res.Data;
		} else {
			return null;
		}
	},

	// thực hiện lấy thông tin người thụ hưởng
	getInfoTax: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: GipAPI.getAPIUrl() + '/gip',
				params: payload
			},
			true
		);

		if (res.Success) {
			return res.Data;
		}

		return null;
	},

	/**
	 * Lấy danh sách khảo sát và kiểm tra xem có hiển thị khảo sát hay không?
	 */
	checkServeys: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: NpsAPI.getAPIUrl() + '/check-serveys',
			params: payload
		});
		if (res.Success) {
			context.commit('updateGetServey', res);
			return res;
		}
		return null;
	},

	// Gửi kết quả khảo sát
	saveServey: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: NpsAPI.getAPIUrl() + '/save',
				data: payload
			},
			true
		);
		return res;
	},

	// Khi không làm servey thì send cái này
	cancelServey: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: NpsAPI.getAPIUrl() + '/cancel',
			data: payload
		});
		return res;
	},

	/**
	 * Lấy danh sách khảo sát và kiểm tra xem có hiển thị khảo sát hay không?
	 */
	getServeys: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: NpsAPI.getAPIUrl() + '/serveys',
			params: payload
		});
		return res;
	},

	/**
	 * Danh sách thủ tục hành chính
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	loadAllAdminProcedure: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: AdminProcedureAPI.getAPIUrl() + '/getall',
				params: payload
			},
			true
		);
		if (res.Success) {
			context.commit('updateAdminProcedureList', res);
			return res.Data;
		}
		return [];
	}
};
